<!-- This file is generated by @sveltejs/kit — do not edit it! -->
<script>
	import { setContext, afterUpdate, onMount } from 'svelte';

	// stores
	export let stores;
	export let page;

	export let components;
	export let data_0 = null;
	export let data_1 = null;
	export let data_2 = null;
	export let data_3 = null;
	export let errors;

	setContext('__svelte__', stores);

	$: stores.page.set(page);
	afterUpdate(stores.page.notify);

	let mounted = false;
	let navigated = false;
	let title = null;

	onMount(() => {
		const unsubscribe = stores.page.subscribe(() => {
			if (mounted) {
				navigated = true;
				title = document.title || 'untitled page';
			}
		});

		mounted = true;
		return unsubscribe;
	});
</script>

{#if components[1]}
	<svelte:component this={components[0]} data={data_0}>
		{#if components[2]}
			<svelte:component this={components[1]} data={data_1}>
				{#if components[3]}
					<svelte:component this={components[2]} data={data_2}>
						<svelte:component this={components[3]} data={data_3}/>
					</svelte:component>
				{:else}
					<svelte:component this={components[2]} data={data_2} {errors} />
				{/if}
			</svelte:component>
		{:else}
			<svelte:component this={components[1]} data={data_1} {errors} />
		{/if}
	</svelte:component>
{:else}
	<svelte:component this={components[0]} data={data_0} {errors} />
{/if}

{#if mounted}
	<div id="svelte-announcer" aria-live="assertive" aria-atomic="true" style="position: absolute; left: 0; top: 0; clip: rect(0 0 0 0); clip-path: inset(50%); overflow: hidden; white-space: nowrap; width: 1px; height: 1px">
		{#if navigated}
			{title}
		{/if}
	</div>
{/if}